{
  "version": 1,
  "asset_id": "cf515875-e15e-41d4-afab-1666a071178a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/cf515875-e15e-41d4-afab-1666a071178a/sleeve-fitzer-2-220.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/cf515875-e15e-41d4-afab-1666a071178a/sleeve-fitzer-2-220.png",
  "original_filename": "sleeve-fitzer-2-220.png",
  "size": 39016,
  "content_type": "image/png",
  "created_at": "2026-09-29T01:15:38Z"
}
